"use client"

import { Card, Col, Row } from "antd"
import FormSearchTours from "./FormSearch"
import ToursCollection from "./ToursCollection"
import NearlySeenTours from "./NearlySeenTours"
import { useToursCollections } from "@/hooks/tour/useToursCollections"
import PageLoading from "../common/PageLoading"
import { useRef } from "react"
import { useAppDispatch } from "@/lib/redux/hooks"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import MKTScript from "../MKTScript"

const refSSR: any = { current: false }

const Tours = ({ collectionData }: any) => {
  const dispatch = useAppDispatch()

  if (!refSSR.current) {
    refSSR.current = true
    dispatch(tourActions.setCollectionData(collectionData))  
  }

  return (
    <Row
      justify='center'
    >
      <MKTScript />
      <Col
        span={24}
        style={{
          paddingTop: '3rem',
          paddingBottom: '15rem',
          backgroundImage: `url("/static/bg-tours-search-section.webp")`,
          backgroundSize: 'cover',
          backgroundPosition: 'bottom center',
          
        }}
      >
        <Row justify='center'>
          <Col xs={24} sm={24} lg={17} xl={16} xxl={{ flex: "101rem" }} className="tours__search">
            <Card
              variant="borderless"
              size="small"
              className="home__searching--form home__searching--form--standalone"
            >
              <FormSearchTours size="small" />
            </Card>
          </Col>
        </Row>
      </Col>
      <Col span={24} className="tours">
        <NearlySeenTours />
        {collectionData.collections.map((collection: any, index: number) => {
          return (
            <ToursCollection
              key={collection?.id ?? collection?.slug ?? index}
              collection={collection}
            />
          )
        })}
      </Col>
    </Row>
  )
}

export default Tours